// extracted by mini-css-extract-plugin
export default {"container":"Auth_container__X3cWi","img-container":"Auth_img-container__DDN7J"};